import QuanLyChucVu from "@app/pages/danhmuc/QuanLyChucVu";
import XemDonNghiPhep from "@app/pages/phep/XemDonNghiPhep";
import ChamCongThang from "@pages/chamcong/ChamCongThang";
import ChiTietBaoHiem from "../pages/baohiem/ChiTietBaoHiem";
import DanhSachBaoHiem from "../pages/baohiem/DanhSachBaoHiem";
import ThemBaoHiem from "../pages/baohiem/ThemBaoHiem";
import ChamNgoaiGio from "../pages/chamcong/ChamNgoaiGio";
import PheDuyetChamCongThang from "../pages/chamcong/PheDuyetChamCongThang";
import PheDuyetChamNgoaiGio from "../pages/chamcong/PheDuyetChamNgoaiGio";
import QuanTriChamCongThang from "../pages/chamcong/QuanTriChamCongThang";
import QuanTriChamNgoaiGio from "../pages/chamcong/QuanTriChamNgoaiGio";
import ThongKeChamCong from "../pages/chamcong/ThongKeChamCong";
import DanhSachChucNang from "../pages/chucnang/DanhSachChucNang";
import PhanChucNang from "../pages/chucnang/PhanChucNang";
import DanhSachCongViec from "../pages/congviec/DanhSachCongViec";
import GiaoCongViec from "../pages/congviec/GiaoCongViec";
import ThemCongViec from "../pages/congviec/ThemCongViec";
import XemCongViec from "../pages/congviec/XemCongViec";
import QuanLyBacLuong from "../pages/danhmuc/QuanLyBacLuong";
import QuanLyChucDanhChuyenMon from "../pages/danhmuc/QuanLyChucDanhChuyenMon";
import QuanLyChucVuDang from "../pages/danhmuc/QuanLyChucVuDang";
import QuanLyChucVuDoan from "../pages/danhmuc/QuanLyChucVuDoan";
import QuanLyHeSoLuong from "../pages/danhmuc/QuanLyHeSoLuong";
import QuanLyLoaiHopDong from "../pages/danhmuc/QuanLyLoaiHopDong";
import QuanLyNhomNhanSu from "../pages/danhmuc/QuanLyNhomNhanSu";
import ChiTietLopDaoTao from "../pages/daotao/ChiTietLopDaoTao";
import DanhSachLopDaoTao from "../pages/daotao/DanhSachLopDaoTao";
import XemLopDaoTao from "../pages/daotao/XemLopDaoTao";
import BaoCaoDaoTao from "../pages/daotao/BaoCaoDaoTao";
import ChiTietDonVi from "../pages/donvi/ChiTietDonVi";
import DanhSachDonVi from "../pages/donvi/DanhSachDonVi";
import CanhBaoHetHan from "../pages/hopdong/CanhBaoHetHan";
import DanhSachHopDongTheoNV from "../pages/hopdong/DanhSachTheoNhanVien";
import XemChiTietHopDong from "../pages/hopdong/XemChiTietHopDong";
import ChiTietKPI from "../pages/kpi/ChiTietKPI";
import DuyetKPI from "../pages/kpi/DuyetKPI";
import KPICaNhan from "../pages/kpi/KPICaNhan";
import KPIPhongBan from "../pages/kpi/KPIPhongBan";
import DanhSachLuong from "../pages/luong/DanhSachLuong";
import DanhSachLuongCoBan from "../pages/luong/DanhSachLuongCoBan";
import KhenThuongUngHo from "../pages/luong/KhenThuongUngHo";
import QuanLyLuong from "../pages/luong/QuanLyLuong";
import ChiTietNgayNghi from "../pages/ngaynghi/ChiTietNgayNghi";
import DanhSachNgayNghi from "../pages/ngaynghi/DanhSachNgayNghi";
import DanhSachNguoiDung from "../pages/nguoidung/DanhSachNguoiDung";
import ChiTietNhanVien from "../pages/nhanvien/ChiTietNhanVien";
import DanhSachNhanVien from "../pages/nhanvien/DanhSachNhanVien";
import NguoiPhuThuocPage from "../pages/nhanvien/NguoiPhuThuocPage";
import XemNhanVien from "../pages/nhanvien/XemNhanVien";
import ThuNhapCaNhan from "../pages/profile/ThuNhapCaNhan";
import ChiTietQuyen from "../pages/quyen/ChiTietQuyen";
import DanhSachQuyen from "../pages/quyen/DanhSachQuyen";
import PhanQuyen from "../pages/quyen/PhanQuyen";
import Setting from "../pages/setting/Setting";
import CauHinhPhuCap from "../pages/danhmuc/CauHinhPhuCap";
import { Links } from "./Links";
import DanhSachDangKyPhep from "../pages/phep/DanhSachDangKyPhep";
import ChiTietPhep from "../pages/phep/ChiTietPhep";
import DanhSachDuyetDonNghiPhep from "../pages/phep/DanhSachDuyetDonNghiPhep";
import CauHinhNguoiPheDuyet from "../pages/phep/CauHinhNguoiPheDuyet";
import QuanLyNgayPhepTrongNam from "../pages/phep/QuanLyNgayPhepTrongNam";
import QuanLyChuyenNganhDaoTao from "../pages/danhmuc/QuanLyChuyenNganhDaoTao";
import XemHopDongCaNhan from "../pages/hopdong/XemHopDongCaNhan";
import XemHoSoCaNhan from "../pages/hosocanhan/XemHoSoCaNhan";
import DangKyThemGio from "../pages/ngoaigio/DangKyThemGio";
import DanhSachDangKyThemGio from "../pages/ngoaigio/DanhSachDangKyThemGio";
import PheDuyetThemGio from "../pages/ngoaigio/PheDuyetThemGio";
import ThueTNCN from "../pages/thue/ThueTNCN";
import QuanTriTinhThueThang from "../pages/thue/QuanTriTinhThueThang";
import XemThemGio from "../pages/ngoaigio/XemThemGio";
import DanhSachKhenThuongUngHo from "../pages/luong/DanhSachKhenThuongUngHo";
import DanhSachPhatSinhTinhThue from "../pages/luong/phatsinhtinhthue/DanhSachPhatSinhTinhThue";
import PhatSinhTinhThue from "../pages/luong/phatsinhtinhthue/PhatSinhTinhThue";
import CauHinhNguoiYKien from "../pages/phep/CauHinhNguoiYKien";
import DanhSachLuongBoSung from "../pages/luong/DanhSachLuongBoSung";
import DanhSachLuongBoSungNQL from "../pages/luong/luongBoSungNQL/DanhSachLuongBoSungNQL";
import LuongBoSungNQL from "../pages/luong/luongBoSungNQL/LuongBoSungNQL";
import LuongBoSungNLD from "../pages/luong/LuongBoSungNLD";
import DanhSachThuLaoNDD from "../pages/luong/thulaonguoidaidien/DanhSachThuLaoNDD";
import ThuLaoNDD from "../pages/luong/thulaonguoidaidien/ThuLaoNDD";
import DanhSachPhuCapTGV from "../pages/luong/phucaptogiupviec/DanhSachPhuCapTGV";
import ChiTietPhuCapTGV from "../pages/luong/phucaptogiupviec/ChiTietPhuCapTGV";
import DanhSachThuLaoKCT from "../pages/luong/thulaoQLkhongchuyentrach/DanhSachThuLaoKCT";
import ChiTietThuLaoKCT from "../pages/luong/thulaoQLkhongchuyentrach/ChiTietThuLaoKCT";
import ChiTietLuongCoBan from "../pages/luong/ChiTietLuongCoBan";
import DanhSachLuongPhuCap from "../pages/luong/DanhSachLuongPhuCap";
import ChiTietLuongPhuCap from "../pages/luong/ChiTietLuongPhuCap";
import DanhSachLuongHoanThanhNhiemVu from "../pages/luong/DanhSachLuongHoanThanhNhiemVu";
import ChiTietLuongHoanThanhNhiemVu from "../pages/luong/ChiTietLuongHoanThanhNhiemVu";
import QuanLyThongBaoLogin from "../pages/danhmuc/QuanLyThongBaoLogin";
import PhoGiamDocPhuTrach from "../pages/setting/PhoGiamDocPhuTrach";
import CauHinhHopDong from "../pages/setting/CauHinhHopDong";
import ChiTietHopDongDienTu from "../pages/hopdong/ChiTietHopDongDienTu";
import DanhSachHopDongDienTu from "../pages/hopdong/DanhSachHopDongDienTu";
import QuanLyQuyetDinh from "../pages/danhmuc/QuanLyQuyetDinh";
import QuanLyNhanSuKhac from "../pages/nhansukhac/QuanLyNhanSuKhac";
import DanhSachThemGioTongHop from "../pages/ngoaigio/DanhSachThemGioTongHop";
import DanhSachPhepTongHop from "../pages/phep/DanhSachPhepTongHop";
import QLNhomLyDoNghiViec from "../pages/danhmuc/QLNhomLyDoNghiViec";
import DanhSachToBan from "../pages/toban/DanhSachToBan";
import XemToBan from "../pages/toban/XemToBan";
import ChiTietToBan from "../pages/toban/ChiTietToBan";
import ChiTietKhenThuongNhanSuKhac from "../pages/luong/khenThuongNhanSuKhac/ChiTietKhenThuongNhanSuKhac";
import DanhSachKhenThuongNhanSuKhac from "../pages/luong/khenThuongNhanSuKhac/DsKhenThuongNhanSuKhac";
import DanhSachThueThangKhongThuongXuyen from "../pages/thue/DSThueThangKhongThuongXuyen";
import ChiTietThueThangKhongThuongXuyen from "../pages/thue/ChiTietThueThangKhongThuongXuyen";
import DsQuyetToanThueThuongXuyen from "../pages/thue/DSQuyetToanThueThuongXuyen";
import ChiTietQuyetToanThueThuongXuyen from "../pages/thue/ChiTietQuyetToanThueThuongXuyen";
import TongHopThueKTXTheoNam from "../pages/thue/TongHopThueKhongThuongXuyenTheoNam";
import QuanTriTongHopThue from "../pages/thue/QuanTriTongHopThue";
import ChiTietTongHopThue from "../pages/thue/ChiTietTongHopThue";
import TrinhDoHV from "../pages/danhmuc/TrinhDoHV";
import QuanLyDMCoSo from "../pages/danhmuc/QuanLyDMCoSo";
import QuanLyDMBoPhanKiemKe from "../pages/danhmuc/QuanLyDMBoPhanKiemKe";
import ThongKeNhanSu from "../pages/nhanvien/ThongKe";
import SuaThongTinCaNhan from "../pages/hosocanhan/SuaThongTinCaNhan";
import TongHopDangKy from "../pages/dangkydaotao/TongHopDangKy";
import DanhSachBienBanBanGiao from "../pages/taisan/DanhSachBienBanBanGiao";
import ChiTietBienBanBanGiao from "../pages/taisan/ChiTietBienBanBanGiao";
import XemBienBanBanGiao from "../pages/taisan/XemBienBanBanGiao";
import DanhSachThanhLyTaiSan from "../pages/taisan/DanhSachThanhLyTaiSan";
import ChiTietThanhLyTaiSan from "../pages/taisan/ChiTietThanhLyTaiSan";
import XemThanhLyTaiSan from "../pages/taisan/XemThanhLyTaiSan";
import ChiTietDotDangKyDaoTao from "../pages/dangkydaotao/ChiTietDotDangKyDaoTao";
import XemDotDangKyDaoTao from "../pages/dangkydaotao/XemDotDangKyDaoTao";
import ChiTietCaNhan from "../pages/dangkydaotao/ChiTietCaNhan";
import DanhSachCaNhan from "../pages/dangkydaotao/DanhSachCaNhan";
import DuyetDangKyDaoTao from "../pages/dangkydaotao/DuyetDangKyDaoTao";
import DanhSachTaiSan from "../pages/taisan/DanhSachTaiSan";
import ChiTietTaiSan from "../pages/taisan/ChiTietTaiSan";
import XemTaiSan from "../pages/taisan/XemTaiSan";
import DanhSachDotKiemKe from "../pages/taisan/DanhSachDotKiemKe";
import ChiTietDotKiemKe from "../pages/taisan/ChiTietDotKiemKe";
import KiemKeTaiSan from "../pages/taisan/KiemKeTaiSan";
import ChiTietBienBanKiemKe from "../pages/taisan/ChiTietBienBanKiemKe";
import KeKhaiTaiSanPage from "../pages/taisan/KeKhaiTaiSanPage";
import DanhSachDeXuatNhuCau from "../pages/taisan/DanhSachDeXuatNhuCau";
import ChiTietDeXuatNhuCau from "../pages/taisan/ChiTietDeXuatNhuCau";
import XemDeXuatNhuCau from "../pages/taisan/XemDeXuatNhuCau";
import DanhSachLuongBoSungTruongBKS from "../pages/luong/DanhSachLuongBoSungTruongBKS";
import ChiTietLuongBoSungTruongBKS from "../pages/luong/ChiTietLuongBoSungTruongBKS";
import ChiTietLuongThemGio from "../pages/luong/ChiTietLuongThemGio";
import DanhSachLuongThemGio from "../pages/luong/DanhSachLuongThemGio";
import YKienKPIPhoGiamDoc from "../pages/kpi/YKienKPIPhoGiamDoc";
import ThongKeKPI from "../pages/kpi/ThongKeKPI";
import QuanLyQuyLuong from "../pages/luong/QuanLyQuyLuong";
import DanhSachCongDoanPhi from "../pages/luong/congdoanphi/DanhSachCongDoanPhi";
import CongDoanPhi from "../pages/luong/congdoanphi/CongDoanPhi";
export const routers = [
    {
        [Links.DonVi.ChiTiet]: <ChiTietDonVi />,
        [Links.DonVi.DanhSach]: <DanhSachDonVi />
    },
    {
        [Links.NguoiDung.DanhSach]: <DanhSachNguoiDung />
    },
    {
        [Links.NhanSuKhac.DanhSach]: <QuanLyNhanSuKhac />,
        [Links.NhanSuKhac.LuongKhenThuong]: < DanhSachKhenThuongNhanSuKhac />,
        [Links.NhanSuKhac.ChiTietLuongKhenThuong]: < ChiTietKhenThuongNhanSuKhac />,
    },
    {
        [Links.NhanVien.Xem]: <XemNhanVien />,
        [Links.NhanVien.ChiTiet]: <ChiTietNhanVien />,
        [Links.NhanVien.ThongKe]: <ThongKeNhanSu />,
        [Links.NhanVien.DanhSach]: <DanhSachNhanVien />
    },
    {
        [Links.NguoiPhuThuoc.CaNhan]: <NguoiPhuThuocPage />
    },
    {
        [Links.HoSoCaNhan.SuaCoBan]: <SuaThongTinCaNhan />,
        [Links.HoSoCaNhan.SuaDayDu]: <SuaThongTinCaNhan />,
        [Links.HoSoCaNhan.Xem]: <XemHoSoCaNhan />,
    },
    {
        [Links.ChucNang.DanhSach]: <DanhSachChucNang />,
        [Links.ChucNang.PhanChucNang]: <PhanChucNang />
    },
    {
        [Links.Quyen.ChiTiet]: <ChiTietQuyen />,
        [Links.Quyen.DanhSach]: <DanhSachQuyen />,
        [Links.Quyen.PhanQuyen]: <PhanQuyen />
    },
    {
        [Links.Setting.CauHinhHeThong]: <Setting />,
        [Links.Setting.PGDPhuTrach]: <PhoGiamDocPhuTrach />
    },
    {
        [Links.ChamCong.ChiTietChamCongThang]: <ChamCongThang />,
        [Links.ChamCong.QuanTriChamCongThang]: <QuanTriChamCongThang />,
        [Links.ChamCong.DuyetChamCong]: <PheDuyetChamCongThang />,
        [Links.ChamCong.ChiTietChamNgoaiGio]: <ChamNgoaiGio />,
        [Links.ChamCong.QuanTriChamNgoaiGio]: <QuanTriChamNgoaiGio />,
        [Links.ChamCong.DuyetNgoaiGio]: <PheDuyetChamNgoaiGio />,
        [Links.ChamCong.ThongKeChamCong]: <ThongKeChamCong />,
    },
    {
        [Links.HopDong.Xem]: <XemChiTietHopDong />,
        [Links.HopDong.CaNhan]: <XemHopDongCaNhan />,
        [Links.HopDong.DanhSach]: <DanhSachHopDongTheoNV />,
        [Links.HopDong.CauHinhMau]: <CauHinhHopDong />,
        [Links.HopDong.ChiTietHopDongDienTu]: <ChiTietHopDongDienTu />,
        [Links.HopDong.HopDongDienTu]: <DanhSachHopDongDienTu />,
        [Links.HopDong.CanhBao]: <CanhBaoHetHan />
    },
    {
        [Links.KPI.KPICaNhan]: <KPICaNhan />,
        [Links.KPI.ChiTietKPI]: <ChiTietKPI />,
        [Links.KPI.KPIPhongBan]: <KPIPhongBan />,
        [Links.KPI.DuyetKPI]: <DuyetKPI />,
        [Links.KPI.YKienKPI]: <YKienKPIPhoGiamDoc />,
        [Links.KPI.ThongKe]: <ThongKeKPI />
    },
    {
        [Links.BaoHiem.Xem]: <ChiTietBaoHiem />,
        [Links.BaoHiem.Them]: <ThemBaoHiem />,
        [Links.BaoHiem.DanhSach]: <DanhSachBaoHiem />,
    },
    {
        [Links.ThuNhapCaNhan.XemThuNhap]: <ThuNhapCaNhan />
    },
    {
        [Links.DaoTao.ChiTiet]: <ChiTietLopDaoTao />,
        [Links.DaoTao.Xem]: <XemLopDaoTao />,
        [Links.DaoTao.DanhSach]: <DanhSachLopDaoTao />,
        [Links.DaoTao.BaoCao]: <BaoCaoDaoTao />,
    },
    {
        [Links.DangKyDaoTao.DanhSachNam]: <TongHopDangKy />,
        [Links.DangKyDaoTao.ChiTiet]: <ChiTietDotDangKyDaoTao />,
        [Links.DangKyDaoTao.Xem]: <XemDotDangKyDaoTao/>,
        [Links.DangKyDaoTao.DanhSachCaNhan]: <DanhSachCaNhan />,
        [Links.DangKyDaoTao.ChiTietCaNhan]: <ChiTietCaNhan />,
        [Links.DangKyDaoTao.PheDuyetCaNhan]: <DuyetDangKyDaoTao />,
    },
    {
        [Links.Luong.QuanLyLuong]: <QuanLyLuong />,
        [Links.Luong.DanhSach]: <DanhSachLuong />,
        [Links.Luong.BoSung]: <DanhSachLuongBoSung />,
        [Links.Luong.ChiTietLuongBoSung]: <LuongBoSungNLD />,
        [Links.Luong.ChiTietThueThang]: <ThueTNCN />,
        [Links.Luong.QuanTriTinhThue]: <QuanTriTinhThueThang />,
        [Links.Luong.ChiTietKhenThuongUngHo]: <KhenThuongUngHo />,
        [Links.Luong.KhenThuongUngHo]: <DanhSachKhenThuongUngHo />,
        [Links.Luong.CongDoanPhi]: <DanhSachCongDoanPhi />,
        [Links.Luong.ChiTietCongDoanPhi]: <CongDoanPhi />,
        [Links.Luong.PhatSinhTinhThue]: <DanhSachPhatSinhTinhThue />,
        [Links.Luong.ChiTietPhatSinhTinhThue]: <PhatSinhTinhThue />,

        [Links.Luong.ThanhToanLuongNQL]: <DanhSachLuongBoSungNQL />,
        [Links.Luong.ChiTietThanhToanLuongNQL]: <LuongBoSungNQL />,
        [Links.Luong.DanhSachPhuCapTGV]: <DanhSachPhuCapTGV />,
        [Links.Luong.ChiTietPhuCapTGV]: <ChiTietPhuCapTGV />,
        [Links.Luong.DanhSachLuongCoBan]: <DanhSachLuongCoBan />,
        [Links.Luong.ChiTietLuongCoBan]: <ChiTietLuongCoBan />,
        [Links.Luong.DanhSachLuongPhuCap]: <DanhSachLuongPhuCap />,
        [Links.Luong.ChiTietLuongPhuCap]: <ChiTietLuongPhuCap />,
        [Links.Luong.DanhSachLuongHoanThanhNhiemVu]: <DanhSachLuongHoanThanhNhiemVu />,
        [Links.Luong.ChiTietLuongHoanThanhNhiemVu]: <ChiTietLuongHoanThanhNhiemVu />,
        [Links.Luong.DanhSachLuongBoSungTruongBKS]: <DanhSachLuongBoSungTruongBKS />,
        [Links.Luong.ChiTietLuongBoSungTruongBKS]: <ChiTietLuongBoSungTruongBKS />,
        [Links.Luong.DanhSachLuongThemGio]: <DanhSachLuongThemGio />,
        [Links.Luong.ChiTietLuongThemGio]: <ChiTietLuongThemGio />,
        [Links.Luong.QuanLyQuyLuong]: <QuanLyQuyLuong />,
    },
    {
        [Links.ThuLaoNguoiDaiDien.DanhSach]: <DanhSachThuLaoNDD />,
        [Links.ThuLaoNguoiDaiDien.ChiTiet]: <ThuLaoNDD />,
    },
    {
        [Links.ThuLaoKhongChuyenTrach.DanhSach]: <DanhSachThuLaoKCT />,
        [Links.ThuLaoKhongChuyenTrach.ChiTiet]: <ChiTietThuLaoKCT />,
    },
    {
        [Links.Phep.ChiTiet]: <ChiTietPhep />,
        [Links.Phep.Xem]: <XemDonNghiPhep />,
        [Links.Phep.DanhSachDangKy]: <DanhSachDangKyPhep />,
        [Links.Phep.DanhSachPheDuyet]: <DanhSachDuyetDonNghiPhep />,
        [Links.Phep.CauHinh]: <CauHinhNguoiPheDuyet />,
        [Links.Phep.QuanLyPhepNam]: <QuanLyNgayPhepTrongNam />,
        [Links.Phep.DanhSachDangKy]: <DanhSachDangKyPhep />,
        [Links.Phep.CauHinhYKien]: <CauHinhNguoiYKien />,
        [Links.Phep.TongHop]: <DanhSachPhepTongHop />,
    },
    {
        [Links.NgoaiGio.DangKy]: <DangKyThemGio />,
        [Links.NgoaiGio.DanhSach]: <DanhSachDangKyThemGio />,
        [Links.NgoaiGio.PheDuyet]: <PheDuyetThemGio />,
        [Links.NgoaiGio.Xem]: <XemThemGio />,
        [Links.NgoaiGio.TongHop]: <DanhSachThemGioTongHop />
    },
    {

        [Links.NgayNghi.ChiTiet]: <ChiTietNgayNghi />,
        [Links.NgayNghi.DanhSach]: <DanhSachNgayNghi />,
    },
    {
        [Links.DanhMuc.ChucVu]: <QuanLyChucVu />,
        [Links.DanhMuc.LoaiHopDong]: <QuanLyLoaiHopDong />,
        [Links.DanhMuc.NhomNhanSu]: <QuanLyNhomNhanSu />,
        [Links.DanhMuc.BacLuong]: <QuanLyBacLuong />,
        [Links.DanhMuc.HeSoLuong]: <QuanLyHeSoLuong />,
        [Links.DanhMuc.ChucDanhChuyenMon]: <QuanLyChucDanhChuyenMon />,
        [Links.DanhMuc.ChucVuDang]: <QuanLyChucVuDang />,
        [Links.DanhMuc.ChucVuDoan]: <QuanLyChucVuDoan />,
        [Links.DanhMuc.CauHinhPhuCap]: <CauHinhPhuCap />,
        [Links.DanhMuc.ChuyenNganhDaoTao]: <QuanLyChuyenNganhDaoTao />,
        [Links.DanhMuc.QuanLyThongBaoLogin]: <QuanLyThongBaoLogin />,
        [Links.DanhMuc.NhomLyDoNghiViec]: <QLNhomLyDoNghiViec />,
        [Links.DanhMuc.QuyetDinh]: <QuanLyQuyetDinh />,
        [Links.DanhMuc.TrinhDoHV]: <TrinhDoHV />,
        [Links.DanhMuc.DMCoSo]: <QuanLyDMCoSo />,
        [Links.DanhMuc.DMBoPhanKiemKe]: <QuanLyDMBoPhanKiemKe />,
    },
    {
        [Links.CongViec.Them]: <ThemCongViec />,
        [Links.CongViec.GiaoViec]: <GiaoCongViec />,
        [Links.CongViec.Xem]: <XemCongViec />,
        [Links.CongViec.DanhSach]: <DanhSachCongViec />,
    },
    {
        [Links.ToBan.Xem]: <XemToBan />,
        [Links.ToBan.ChiTiet]: <ChiTietToBan />,
        [Links.ToBan.DanhSach]: <DanhSachToBan />,
    },
    {
        [Links.Thue.ChiTietThueKhongThuongXuyen]: <ChiTietThueThangKhongThuongXuyen />,
        [Links.Thue.DsThueKhongThuongXuyen]: <DanhSachThueThangKhongThuongXuyen />,
        [Links.Thue.DsQuyetToanThuongXuyen]: <DsQuyetToanThueThuongXuyen />,
        [Links.Thue.ChiTietQuyetToanThuongXuyen]: <ChiTietQuyetToanThueThuongXuyen />,
        [Links.Thue.TongHopThueKTXTheoNam]: <TongHopThueKTXTheoNam />,
        [Links.Thue.ChiTietTongHopThue]: <ChiTietTongHopThue />,
        [Links.Thue.TongHopThue]: <QuanTriTongHopThue />
    },
    {
        [Links.TaiSan.DanhSach]: <DanhSachTaiSan />,
        [Links.TaiSan.ChiTiet]: <ChiTietTaiSan />,
        [Links.TaiSan.Xem]: <XemTaiSan />,
        [Links.TaiSan.DotKiemKe]: <DanhSachDotKiemKe />,
        [Links.TaiSan.ChiTietDotKiemKe]: <ChiTietDotKiemKe />,
        [Links.TaiSan.KiemKeTaiSan]: <KiemKeTaiSan />,
        [Links.TaiSan.ChiTietBienBanKiemKe]: <ChiTietBienBanKiemKe />,
        [Links.TaiSan.KeKhai]: <KeKhaiTaiSanPage />,
        [Links.KeKhaiTaiSan.DanhSach]: <KeKhaiTaiSanPage />,
    },
    {
        [Links.DeXuatNhuCauTaiSan.DanhSach]: <DanhSachDeXuatNhuCau />,
        [Links.DeXuatNhuCauTaiSan.ChiTiet]: <ChiTietDeXuatNhuCau />,
        [Links.DeXuatNhuCauTaiSan.Xem]: <XemDeXuatNhuCau />
    },
    {
        [Links.BienBanBanGiao.DanhSach]: <DanhSachBienBanBanGiao />,
        [Links.BienBanBanGiao.ChiTiet]: <ChiTietBienBanBanGiao />,
        [Links.BienBanBanGiao.Xem]: <XemBienBanBanGiao />
    },
    {
        [Links.ThanhLyTaiSan.DanhSach]: <DanhSachThanhLyTaiSan />,
        [Links.ThanhLyTaiSan.ChiTiet]: <ChiTietThanhLyTaiSan />,
        [Links.ThanhLyTaiSan.Xem]: <XemThanhLyTaiSan />
    },
];